module.exports = __webpack_public_path__ + "static/media/spider-black-widow.22f8d342.svg";